// extracted by mini-css-extract-plugin
export default {"customernumber":"NavigationCustomerNumber-gIXIL__customernumber","icon":"NavigationCustomerNumber-+k785__icon","text":"NavigationCustomerNumber-yyfaS__text"};